import { Checkbox, Form, List, Typography } from "antd";
import React from "react";
import get from "lodash/get";

const SelectFeaturePermissions = ({ feature_permissions }) => {
  const { Title } = Typography;
  return (
    <Form.Item
      name="feature_permissions"
      label={<Title level={5}>Select Feature</Title>}
       rules={[
        {
          required: true,
          message: "Please select at least one feature!",
        },
      ]}
    >
      <Checkbox.Group className="w-full">
        <List
          className="w-full"
          dataSource={Object.values(feature_permissions)}
          renderItem={(feature) => (
            <List.Item>
              <Checkbox value={get(feature, "value")}>
                {get(feature, "name")}
              </Checkbox>
            </List.Item>
          )}
        ></List>
      </Checkbox.Group>
    </Form.Item>
  );
};

export default SelectFeaturePermissions;
